/**
 *
 * Asynchronously loads the component for CornucopiaScreenEditor
 *
 */

import Loadable from 'react-loadable';
import Spinner from 'components/FullScreenSpinner';

export default Loadable({
  loader: () => import('./index'),
  loading: Spinner,
});
